// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Jobs service - pure async functions for fetching job status.
 */
import type { NodeApiClient } from '@/app-shell/services'

/** Job status from API */
export interface JobStatus {
  jobId: string
  status: 'PENDING' | 'RUNNING' | 'COMPLETED' | 'ERROR'
  processName: string
  createdAt: string
  startedAt?: string
  completedAt?: string
  progressCompleted?: number
  progressTotal?: number
  // cm-coding: Users polling a failed job need an actionable reason after the
  // worker invocation and its logs are gone. Return only the sanitized error
  // persisted on the job; exposing the original exception could leak provider
  // data or implementation details to the browser.
  error?: string
}

/**
 * Fetch status of a single job.
 */
export async function fetchJobStatus(
  apiClient: NodeApiClient,
  orgId: string,
  wsId: string,
  jobId: string,
): Promise<JobStatus> {
  const url = `/org/${orgId}/ws/${wsId}/jobs/${jobId}`
  const res = await apiClient.get<JobStatus>(url)
  return res.data
}
